import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="es-status-page">
      <p className="es-status-page__eyebrow">Error 404</p>
      <h1 className="es-status-page__title">We couldn&rsquo;t find that page</h1>
      <p className="es-status-page__body">
        The page you were looking for may have moved, or the link that brought
        you here may be out of date.
      </p>
      <div className="es-status-page__actions">
        <Link className="es-btn es-btn--primary" to="/">
          Back to home
        </Link>
        <Link className="es-btn es-btn--ghost" to="/events">
          Browse events
        </Link>
      </div>
    </div>
  );
}
